/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Billing_WriteInputs */



/**
* | output |
* | --- |
* | "Manage the plan, payments and subscriptions" |
*
* @param {Perm_Team_Billing_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_billing_write = /** @type {((inputs?: Perm_Team_Billing_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Billing_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управлять тарифом, платежами и подписками")
	return /** @type {LocalizedString} */ ("Manage the plan, payments and subscriptions")
});